<div class="container mt-5 mb-5">
  <div class="d-none d-md-block">
    <app-subscription-table-desktop
     id="subscription-table"
     [identibasePlusButtonLabel]="'Learn more'"
     [identialertButtonLabel]="'Learn more'"
     (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-desktop>
  </div>
  <div class="d-block d-md-none">
    <app-subscription-table-mobile
     id="subscription-table"
     [identibasePlusButtonLabel]="'Learn more'"
     [identialertButtonLabel]="'Buy now'"
     (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-mobile>
  </div>
</div>
